import { render, staticRenderFns } from "./editKindergruppe.vue?vue&type=template&id=a4bd0ab4&scoped=true&"
import script from "./editKindergruppe.vue?vue&type=script&lang=js&"
export * from "./editKindergruppe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bd0ab4",
  null
  
)

export default component.exports